<ul *ngIf="open" [ngClass]="{'request-menu': menuItems.length == 2}" [style.top.px]="top" [style.left.px]="left">
    <li *ngFor="let item of menuItems" (click)="openDialog(item.component)">
        <img [src]="item.icon" [alt]="item.name">
        <span>{{item.name}}</span>
    </li>
</ul>